import { render, staticRenderFns } from "./CommonProfile.vue?vue&type=template&id=4c172e71&scoped=true&"
import script from "./CommonProfile.vue?vue&type=script&lang=js&"
export * from "./CommonProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c172e71",
  null
  
)

export default component.exports